import React from 'react';
import { useContext } from 'react';
import Loader from '../common/Loader';
import { useFetchLiveMatch } from '../data/fetchLiveSingleMatchPage';

export const LiveDataContext = new React.createContext(null);

export function useLiveData() {
    return useContext(LiveDataContext);
}

export default function LiveDataProvider(props) {
    const [request] = useFetchLiveMatch();

    if (request.isError) {
        return <Loader isError={true} />
    }

    return (
        <LiveDataContext.Provider value={request.data}>
            {props.children}
        </LiveDataContext.Provider>
    );
}
